export default {
  openEditPassenger,
  closeEditPassenger,
  selectRelationshipType,
};

function openEditPassenger (passengerId) {
  if (passengerId !== this.state.selectedPassenger) {
    let reservationId = this.props.general ? this.props.general.reservationId : '';
    this.props.getPassengerDetails(passengerId, reservationId);
  }
  this.setState({ editOpened: true, selectedPassenger: passengerId || 0 });
}

function closeEditPassenger () {
  this.setState({ editOpened: false, selectedPassenger: undefined });
}

function selectRelationshipType (e) {
  this.setState({ relationshipType: e.target.value });
}



// WEBPACK FOOTER //
// ./src/containers/passengers/PassengersScreenController.js